import {
  Backup as BackupIcon,
  Dashboard as DashboardIcon,
  Storage as StorageIcon,
  Speed as SpeedIcon,
  People as PeopleIcon,
  Assignment as AssignmentIcon,
  Settings as SettingsIcon,
  Notifications as NotificationsIcon,
  NetworkCheck as NetworkCheckIcon,
  Code as CodeIcon,
} from '@mui/icons-material';
import { Tabs, Tab, Box } from '@mui/material';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AdminNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const adminRoutes = [
    { path: '/admin', label: '시스템 대시보드', icon: <DashboardIcon /> },
    { path: '/admin/database', label: 'DB 통계', icon: <StorageIcon /> },
    { path: '/admin/performance', label: '성능 모니터링', icon: <SpeedIcon /> },
    { path: '/admin/rate-limit', label: 'Rate Limit', icon: <NetworkCheckIcon /> },
    { path: '/admin/users', label: '사용자 관리', icon: <PeopleIcon /> },
    { path: '/admin/task-logs', label: '작업 로그', icon: <AssignmentIcon /> },
    { path: '/admin/settings', label: '시스템 설정', icon: <SettingsIcon /> },
    { path: '/admin/prompts', label: '프롬프트 관리', icon: <CodeIcon /> },
    { path: '/admin/notifications', label: '공지 관리', icon: <NotificationsIcon /> },
    { path: '/admin/backup', label: '백업/복원', icon: <BackupIcon /> },
  ];

  const currentTab = adminRoutes.findIndex(route => 
    route.path === location.pathname,
  );

  const handleTabChange = (event, newValue) => {
    navigate(adminRoutes[newValue].path);
  };

  return (
    <Box sx={{ 
      borderBottom: 1, 
      borderColor: 'divider', 
      mb: 3,
      display: { xs: 'none', md: 'block' }, // 모바일에서는 숨김
    }}>
      <Tabs
        value={currentTab >= 0 ? currentTab : 0}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {adminRoutes.map((route) => (
          <Tab
            key={route.path}
            label={route.label}
            icon={route.icon}
            iconPosition="start"
            sx={{ 
              minHeight: 48,
              textTransform: 'none',
              fontSize: '0.9rem',
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default AdminNavigation;